import e from "../managers/braze-instance.js";
import yt from "./utils/push-utils.js";
export function isPushSupported() {
  if (e.X()) return yt.isPushSupported();
}
